// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2ZTrE","form":"styles_form__22j40","submitBtn":"styles_submitBtn__3faE7","alerts":"styles_alerts__bKTiA","spinner":"styles_spinner__3c7lg"};